import styled from 'styled-components';

import fonts from 'styles/fonts';

import sizes from 'styles/sizes';

export const Title = styled.p`
  color: ${props => props.$color};
  flex-grow: 1;
  line-height: 150%;
  font-family: ${props => props.$fontFamily};
  padding: 0 16px;
  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    padding-left: 0px;
  }
  @media (max-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    width: 90%;
  }
`;

export const Label = styled.span`
  font-weight: ${props => props.$weight};
  line-height: 150%;
  ${props =>
    props.weight === '600' ? `font-family: ${fonts.primary.semibold}` : ''};
  b {
    font-family: ${fonts.primary.semibold};
  }
`;

export const TermsAndConditions = styled.a`
  text-decoration: none;
`;
